// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-grid {
  display: grid;
  gap: 12px;
  padding: 12px;
  height: 100%;
  width: 100%;
  overflow: auto;
  box-sizing: border-box;
  /* La grille est configurée dynamiquement via inline style */
}

/* La grille est désormais calculée dynamiquement via inline styles
   Les classes .grid-1, .grid-2, .grid-4, .grid-6, .grid-many sont conservées
   pour compatibilité mais ne sont plus utilisées par VideoGrid.js */

.video-tile {
  position: relative;
  background-color: #16213e;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 16 / 9;
  width: 100%;
  height: 100%;
  min-height: 120px; /* Hauteur minimale pour petites tuiles */
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-tile-large {
  min-width: 400px;
}

.video-tile video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-tile video.video-hidden {
  display: none;
}

.video-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e94560 0%, #0f3460 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  color: white;
  text-transform: uppercase;
}

.video-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px 12px;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.video-name {
  color: white;
  font-size: 14px;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.video-status {
  display: flex;
  gap: 8px;
}

.status-icon {
  font-size: 14px;
  opacity: 0.9;
}

.status-icon.muted {
  color: #e94560;
}

.status-icon.video-off {
  color: #e94560;
  text-decoration: line-through;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .video-tile {
    min-width: 150px;
    min-height: 120px;
  }
  
  .video-tile-large {
    min-width: 300px;
  }
  
  .avatar {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .video-grid {
    gap: 8px;
    padding: 8px;
  }
}

@media (max-width: 480px) {
  .video-tile {
    min-width: 120px;
    min-height: 90px;
  }
  
  .video-tile-large {
    min-width: 200px;
  }
  
  .avatar {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
  
  .video-info {
    padding: 6px 8px;
  }
  
  .video-name {
    font-size: 12px;
  }
  
  .video-grid {
    gap: 6px;
    padding: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VideoGrid.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,YAAY;EACZ,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;;oEAEoE;;AAEpE;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,yCAAyC;EAC5D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;AACF","sourcesContent":[".video-grid {\n  display: grid;\n  gap: 12px;\n  padding: 12px;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n  /* La grille est configurée dynamiquement via inline style */\n}\n\n/* La grille est désormais calculée dynamiquement via inline styles\n   Les classes .grid-1, .grid-2, .grid-4, .grid-6, .grid-many sont conservées\n   pour compatibilité mais ne sont plus utilisées par VideoGrid.js */\n\n.video-tile {\n  position: relative;\n  background-color: #16213e;\n  border-radius: 12px;\n  overflow: hidden;\n  aspect-ratio: 16 / 9;\n  width: 100%;\n  height: 100%;\n  min-height: 120px; /* Hauteur minimale pour petites tuiles */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.video-tile-large {\n  min-width: 400px;\n}\n\n.video-tile video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-tile video.video-hidden {\n  display: none;\n}\n\n.video-placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #0f3460 0%, #16213e 100%);\n}\n\n.avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #e94560 0%, #0f3460 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 32px;\n  font-weight: bold;\n  color: white;\n  text-transform: uppercase;\n}\n\n.video-info {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 8px 12px;\n  background-color: rgba(0, 0, 0, 0.85);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.video-name {\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.video-status {\n  display: flex;\n  gap: 8px;\n}\n\n.status-icon {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.status-icon.muted {\n  color: #e94560;\n}\n\n.status-icon.video-off {\n  color: #e94560;\n  text-decoration: line-through;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .video-tile {\n    min-width: 150px;\n    min-height: 120px;\n  }\n  \n  .video-tile-large {\n    min-width: 300px;\n  }\n  \n  .avatar {\n    width: 60px;\n    height: 60px;\n    font-size: 24px;\n  }\n  \n  .video-grid {\n    gap: 8px;\n    padding: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-tile {\n    min-width: 120px;\n    min-height: 90px;\n  }\n  \n  .video-tile-large {\n    min-width: 200px;\n  }\n  \n  .avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 18px;\n  }\n  \n  .video-info {\n    padding: 6px 8px;\n  }\n  \n  .video-name {\n    font-size: 12px;\n  }\n  \n  .video-grid {\n    gap: 6px;\n    padding: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
